// src/components/Login.js

import React, { useState } from 'react';
import './Login.css';
import { auth } from '../firebase';
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from 'firebase/auth';
import { Link } from 'react-router-dom';
import { signInWithGoogle, isSignInDismissed } from '../auth/googleSignIn';
const Login = () => {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  const [showResetModal, setShowResetModal] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setGoogleLoading(true);
    try {
      await signInWithGoogle();
    } catch (error) {
      setGoogleLoading(false);
      if (isSignInDismissed(error)) {
        return;
      }
      console.error('Google Sign-In Error:', error);
      if (error.code === 'auth/account-exists-with-different-credential') {
        alert('An account already exists with this email using a different sign-in method. Please sign in with your original method.');
      } else {
        alert('An error occurred during Google sign-in. Please try again.');
      }
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // App.jsx owns backend session sync and navigation after Firebase auth settles.
    } catch (error) {
      console.error('Login Error:', error);
      if (
        error.code === 'auth/invalid-credential'
        || error.code === 'auth/user-not-found'
        || error.code === 'auth/wrong-password'
      ) {
        alert('Invalid email or password.');
      } else {
        alert('An error occurred during login. Please try again.');
      }
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      alert('Password reset email sent! Please check your inbox.');
      setShowResetModal(false);
      setResetEmail('');
    } catch (error) {
      console.error('Password Reset Error:', error);
      if (error.code === 'auth/user-not-found') {
        alert('No user found with this email address.');
      } else if (error.code === 'auth/invalid-email') {
        alert('Please enter a valid email address.');
      } else {
        alert('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-brand">
          <img
            className="login-brand-logo"
            src="/realtorch-brand-name-logo.svg"
            alt="RealTorch"
          />
          <div className="brand-divider" />
        </div>

        <h2 className="login-title">Welcome back</h2>
        <p className="login-subtitle">Sign in to your account to continue</p>

        {!showEmailForm ? (
          <div className="login-methods">
            <button
              type="button"
              className="btn-method btn-method-google"
              onClick={handleGoogleSignIn}
              disabled={googleLoading}
            >
              <svg className="method-icon" viewBox="0 0 24 24" width="20" height="20">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              {googleLoading ? 'Signing in...' : 'Continue with Google'}
            </button>

            <button
              type="button"
              className="btn-method btn-method-email"
              onClick={() => setShowEmailForm(true)}
            >
              <svg className="method-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
              </svg>
              Continue with Email
            </button>
          </div>
        ) : (
          <div className="login-email-form">
            <button
              type="button"
              className="btn-back"
              onClick={() => setShowEmailForm(false)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
              All sign in options
            </button>

            <form onSubmit={handleLogin}>
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-submit">
                Sign In
              </button>
            </form>

            <div className="forgot-password-link">
              <button
                onClick={() => setShowResetModal(true)}
                className="btn-link-subtle"
              >
                Forgot password?
              </button>
            </div>
          </div>
        )}

        <div className="login-footer">
          Don't have an account? <Link to="/sign-up">Sign Up</Link>
        </div>
      </div>

      {/* Password Reset Modal */}
      {showResetModal && (
        <div className="modal-overlay" onClick={() => setShowResetModal(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-card-header">
              <h3>Reset Password</h3>
              <button
                type="button"
                className="modal-close"
                onClick={() => setShowResetModal(false)}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                </svg>
              </button>
            </div>
            <div className="modal-card-body">
              <form onSubmit={handlePasswordReset}>
                <div className="form-field">
                  <label htmlFor="resetEmail">Email Address</label>
                  <input
                    type="email"
                    id="resetEmail"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                  />
                </div>
                <div className="modal-actions">
                  <button type="submit" className="btn-submit">
                    Send Reset Link
                  </button>
                  <button
                    type="button"
                    className="btn-cancel"
                    onClick={() => setShowResetModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
